export const labels = {
  back: "Back to all recipes",
  slug: "/careers/jobs",
  noFilter: ["earlyCareers", "term"],
  term: "term",
  checkboxLabel: "earlyCareers",
  countrycode: "countrycode",
  countrySelectObj: {
    label: "Select country",
    value: "",
  },
  stateSelectObj: {
    label: "Select state/province",
    value: "",
  },
  filterKeys: {
    "jobfamily": "jobFamily",
    "timetype": "timeType",
    "jobtype": "jobType",
    "earlycareers": "earlyCareers"
  },
  locationid: "locationid",
  stateprovincecode: "stateprovincecode",
  itemCount: 20,
  clearFilters: "Clear All Filters",
  newSearch: "New Search",
  watch: "Watch video",
  making: "The makings of the",
  socialIconVar: "socialIconVar",
  philadelphia: "Philadelphia",
  recepieDetail: "recepieDetail",
  recipeDeveloped:
    "A recipe developed exclusively for Philadelphia Professional by Jessica Ayling",
  instagram: "instagram",
  whatsapp: "whatsapp",
  instagramHref: "https://www.instagram.com/philadelphiaprofessional_ukie/",
  productLink: "/range",
  bookmark: "bookmark",
  servings: "Servings",
  min: "min",
  totalTime: "Total time",
  prepTime: "Prep time",
  mail: "mail",
  print: "print",
  servings100: "Per serving 100g",
  servings30: "Per serving 30g",
  imageTextBox: "IMAGE_TEXT_BOX",
  imageLayout: "Image_Layout",
  imageCardsLayout: "Image_Cards_Layout",
  imageTextBoxLayout: "IMAGE_TEXT_BOX_LAYOUT",
  mailSubject: "I found a recipe you may like",
  mailBody:
    "I found this delicious recipe made with Philadelphia. You can check it out here:",
  happyCooking: "There are many more recipes to discover,too. Happy cooking!",
  tabletitle: "Nutritional <strong>Information</strong>",
  noSearchValue: "No search term was entered. Enter a value to search.",
  urls: {
    homepage: "/",
  },
  metaDesRecipe: "Mondelēz International is hiring for ",
  metaDes: "| Review the job and apply today!",
  metaTitle: "Mondelēz International, Inc.",
  beadCrumb: {
    homeBread: "Home",
  },
  header: {
    homepage: "",
    searchPlaceholder: "Search",
    logo: {
      width: 212,
      height: 68,
      ariaLabel: "Mondelez website home page",
    },
  },

  footer: {
    copyRight: {
      text1: "Mondelēz International",
      text2: "All Rights Reserved",
    },
    scrollHeight: 300
  },
  pageTitle: "Home | Mondelēz International, Inc.",
  videoNotSupported: "Your browser does not support the video tag.",

  recipiesForm: {
    firstNameLabel: "First name",
    lastNameLabel: "Last name",
    jobTitleLabel: "Job Title",
    establishmentNameLabel: "Establishment Name",
    workSectorLabel: "Sector you work in",
    wholeSalerLabel: "Preferred wholesaler",
    emailLabel: "Email",
    title: "Free Education Recipe Book",
    description:
      "Fill in your details below to download Nicole's full collection of recipes, including exclusive hints and tips, along with nutritionals and costings for each recipe",
    submitLabel: "Submit",
    submitError:
      "Some information seems incomplete or incorrect. To make corrections please to continue.",
    confirmationCheckboxLabel: "I confirm that I am over 18 years old",
    aggerementCheckboxLabel:
      "If you would like to receive future news, recipes, information on trends and new Philadelphia products by email or paper, please tick this box. If you no longer wish to receive emails or paper, you may unsubscribe here. We value your trust when sharing your personal data with us. We always treat your data in a fair and respectful manner limited to the purpose above mentioned. If you would like to know more about how we handle your data, please read our Privacy Notice.",
  },

  ingredients: {
    title: "Ingredients",
    iamDoneBtn: "I'm done",
    editScaleBtn: "Edit Scales and Units",
    servings: "servings",
    g: "g",
    lbs: "lbs",
  },
  modelheading: "Bookmark shortcuts",
  modelDes1:
    "  To add this recipe to your bookmarks, please use one of the following shortcuts.",
  modelDes2: "  Windows (Internet Explorer, Firefox, etc.)",
  modelDes3: "CTRL+D",
  modelDes4: " MacOS (Safari)",
  modelDes5: "Command(cmd)+D",
  leftArrow: "leftArrow",
  rightArrow: "rightArrow",
  iconNotFound: "Icon not found",
  searchPlaceholder: "What are you looking for?",
  search: "Search",
  youtubePlayer: "YouTube video player",
  sharetxt: "Spread the word, chef! ",
  ingredientsText: "Ingredients",
  productKeys: {
    prdName: "prd_name",
    prdHeading: "philadelphia_product_name",
    prdDesc: "philadelphia_mood",
    prdIngredients: "philadelphia_product_ingredients",
  },
  category: {
    imgs: "imgs",
    texts: "texts",
    nutritions: "nutritions",
  },
  tableHeading: {
    heading: "Nutrional <strong>Information</strong>",
    typicalValues: "Typical values",
    serving: "Nutrition Per 100g",
    gda: "GDA",
    percent: "%",
  },
  gdaValues: {
    Energy: "2000",
    Protein: "50g",
    Carbohydrate: "260g",
    "of which Sugars": "90g",
    Fat: "70g",
    "of which Saturates": "20g",
    Fibre: "24g",
    "Sodium*": "6g",
  },
  energy: "Energy",
  kcal: "kcal",
  kJ: "kJ",
  enjoyCreating: "Enjoy creating",
  nutritionTitle: "Nutritional Information",
  typicalValues: "Typical values",
  perServing: "Per Serving",
  sat_fat: "Sat_fat",
  sodium: "Sodium",
  dit_fibre: "Dietary_fibre",
  saturated_fat: "Saturated fat",
  salt: "Salt",
  dietary_fibre: "Dietary fibre",
  items: [
    {
      id: "1",
      label: "Brands",
      name: "Brands",
    },
    {
      id: "2",
      label: "Business",
      name: "Business",
    },
    {
      id: "3",
      label: "Community Impact",
      name: "Community Impact",
    },
    {
      id: "4",
      label: "Sustainability",
      name: "Sustainability",
    },
    {
      id: "5",
      label: "Careers and People",
      name: "Careers and People",
    },
    {
      id: "6",
      label: "Clear All",
      name: "Clear All",
    },
  ],
  FilterLabel: "Topics",
  filterArray: [
    "Brands",
    "Business",
    "Community Impact",
    "Sustainability",
    "Careers and People",
  ],
  newsHomeDataCNT: "50",
  NEWS_AND_EVENT: "News-and-Events",
  excludedTerms: ["of", "on", "a"],
  Job_Profile_ID: ["JP01843","JP03415","JP01860","JP02513","JP03416","JP03066","JP03421"],
}

export const SORT_TOP_RATED = "Top Rated"
export const SORT_DEFAULT = "Default"
export const SORT_NEWEST = "Newest"
export const SORT_A_TO_Z = "A-Z"
export const SORT_Z_TO_A = "Z-A"
export const TOGGLE_PASSWORD = "togglePassword"
export const PASSWORD = "password"
export const SVG_NAME_SPACE = "https://www.w3.org/2000/svg"
export const JOB_TITLE = "jobTitle"
export const WORK_SECTOR = "workSector"
export const JOB_TITLE_INPUT = "jobTitleInput"
export const WORK_SECTOR_INPUT = "workSectorInput"
export const MANDATORY = "*Mandatory fields"
export const INGREDIENT_PHOTO_ID = 2106
export const BANNER_PHOTO_ID = 2051
export const NUTRITION_PHOTO_ID = 2054
export const PRODUCTIDs = ["95", "96"]
export const PRODUCTIDOLGH = 96
export const PRIVACY_NOTICE = "Privacy Notice"
export const APPID = "05def51a-7539-11ed-a1eb-0242ac120002"
export const APP_SITE_KEY = "6LeLkF8jAAAAABEC1_wVI9cHPdTUOgLv8cH2VtoJ"
export const API_ERROR_MSG = "Something Went Wrong! Please try again"
export const API_SUCCESS_MSG = "Thank you for filling in the form."
export const PREVIOUS = "Previous"
export const NEXT = "Next"
export const REQUIRED_SEARCH = {
  Search: "Search",
  Date: "Date",
  News: "News",
}
export const TextCards = "TextCards"
export const NewsStoryCard = "NewsStoryCard"
export const PAGE_VALUE = 10
export const TOP_BUTTON = "TOP"
export const SEARCH_FIELD = {
  placeholder: "What are you looking for?",
  ariaLabel1: "Search field",
  ariaLabel2: "global search input",
  ariaLabel3: "search",
  link: "/search?term=",
}
export const NotFoundHeading = {
  heading: "The page you are looking for cannot be found.",
  text: "Sorry about that!   Visit the home page or use the Search above and we'll try again.",
}
export const CLEAR_ALL = "clear all"
export const PRESSRELEASE_VARIENT = "YEAR_LANGUAGE"
export const PRESSRELEASE_VARIENT_NOTAB = "NoTab"
export const alphabet = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
]
export const jobFamily = [
  {
    label: "Select function",
    value: "",
  },
  {
    label: "Administration Services",
    value: "JF00001|JF00002",
  },
  {
    label: "Analytics & Data Science",
    value: "JF00003|JF00004",
  },
  {
    label: "Business Capability",
    value: "JF00005|JF00006|JF00007|JF00008|JF00009",
  },
  {
    label: "Corporate & Government Affairs",
    value: "JF00010|JF00011",
  },
  {
    label: "Customer Service & Logistics",
    value:
      "JF00012|JF00013|JF00014|JF00015|JF00016|JF00017|JF00018|JF00019|JF00020",
  },
  {
    label: "Early Careers",
    value: "JF00082|JF00083|JF00084",
  },
  {
    label: "Executive Management",
    value: "JF00022",
  },
  {
    label: "Finance",
    value: "JF00023|JF00024|JF00025|JF00027|JF00029|JF00030",
  },
  {
    label: "Global Business Services",
    value: "JF00031|JF00032|JF00033",
  },
  {
    label: "Human Resources",
    value: "JF00034|JF00035|JF00036",
  },
  {
    label: "Insights",
    value: "JF00037|JF00038|JF00039|JF00040|JF00041",
  },
  {
    label: "Legal",
    value: "JF00042|JF00043",
  },
  {
    label: "Manufacturing",
    value: "JF00044|JF00045|JF00046",
  },
  {
    label: "Marketing",
    value: "JF00047|JF00048|JF00049",
  },
  {
    label: "Procurement",
    value: "JF00050|JF00051|JF00052|JF00053",
  },
  {
    label: "Product Quality, Safety and Compliance",
    value: "JF00055|JF00056|JF00057|JF00058|JF00059",
  },
  {
    label: "Sales",
    value: "JF00060|JF00061|JF00062|JF00063",
  },
  {
    label: "Science & Engineering",
    value:
      "JF00064|JF00065|JF00066|JF00068|JF00069|JF00070|JF00071|JF00072|JF00073|JF00074|JF00075",
  },
  {
    label: "Strategy",
    value: "JF00076",
  },
  {
    label: "Technology & Digital",
    value: "JF00077|JF00078|JF00079|JF00080|JF00081",
  },
]
export const jumpToHeader = "global-header"
export const jumpToFooter = "global-footer"
export const JumpToMainContent = "global-main-content"

export const countryList = [
  {
    label: "Select country",
    value: "",
    selectedLocations: "",
  },
  {
    value: "AR",
    label: "Argentina",
    selectedLocations: ["AR999_JP", "AR003_JP", "AR006_JP", "AR008_JP"],
  },
  {
    value: "AU",
    label: "Australia",
    selectedLocations: [
      "AU012_JP",
      "195_JP",
      "AU004_JP",
      "AU006_JP",
      "AU008_JP",
      "AU011_JP",
      "AU014",
      "AU013_JP",
      "AU014_JP",
      "171_JP",
    ],
  },
  {
    value: "AT",
    label: "Austria",
    selectedLocations: ["AT001_JP", "AT004_JP"],
  },
  {
    value: "BH",
    label: "Bahrain",
    selectedLocations: ["BH"],
  },
  {
    value: "BD",
    label: "Bangladesh",
    selectedLocations: ["BD"],
  },
  {
    value: "BY",
    label: "Belarus",
    selectedLocations: ["AR999_JP", "AR003_JP", "AR006_JP", "AR008_JP"],
  },
  {
    value: "BE",
    label: "Belgium",
    selectedLocations: ["BE004_JP", "BE003_JP", "BE005_JP"],
  },
  {
    value: "BO",
    label: "Bolivia",
    selectedLocations: ["BO"],
  },
  {
    value: "BR",
    label: "Brazil",
    selectedLocations: ["BR999_JP", "BR011_JP", "BR006_JP", "BR007_JP"],
  },
  {
    value: "BG",
    label: "Bulgaria",
    selectedLocations: ["BG001_JP", "BG002_JP"],
  },
  {
    value: "CA",
    label: "Canada",
    selectedLocations: [
      "CA999_JP",
      "CA016_JP",
      "CA013",
      "CA997_JP",
      "CA012_JP",
    ],
  },
  {
    value: "CL",
    label: "Chile",
    selectedLocations: ["CL"],
  },
  {
    value: "CN",
    label: "China",
    selectedLocations: [
      "CN",
      "CN002_JP",
      "CN009_JP",
      "CN999_JP",
      "CN040_JP",
      "CN014_JP",
      "CN015_JP",
      "1012_JP",
      "CN032_JP",
      "CN037_JP",
      "CN041_JP",
      "CN050_JP",
    ],
  },
  {
    value: "CO",
    label: "Colombia",
    selectedLocations: ["CO001_JP", "CO002_JP"],
  },
  {
    value: "CR",
    label: "Costa Rica",
    selectedLocations: ["CR002_JP"],
  },
  {
    value: "HR",
    label: "Croatia",
    selectedLocations: ["HR"],
  },
  {
    value: "CZ",
    label: "Czech Republic",
    selectedLocations: ["CZ001_JP", "CZ003_JP", "CZ004_JP"],
  },
  {
    value: "DK",
    label: "Denmark",
    selectedLocations: ["DK"],
  },
  {
    value: "DO",
    label: "Dominican Republic",
    selectedLocations: ["DO"],
  },
  {
    value: "EC",
    label: "Ecuador",
    selectedLocations: ["EC"],
  },
  {
    value: "EG",
    label: "Egypt",
    selectedLocations: ["EG002_JP", "EG004_JP", "EG999_JP", "EG001"],
  },
  {
    value: "SV",
    label: "El Salvador",
    selectedLocations: ["SV"],
  },
  {
    value: "EE",
    label: "Estonia",
    selectedLocations: ["EE"],
  },
  {
    value: "SZ",
    label: "eSwatini",
    selectedLocations: ["SZ001_JP"],
  },
  {
    value: "FI",
    label: "Finland",
    selectedLocations: ["FI999_JP"],
  },
  {
    value: "FR",
    label: "France",
    selectedLocations: [
      "FR001_JP",
      "FR003_JP",
      "FR004_JP",
      "FR005_JP",
      "FR007_JP",
      "FR999_JP",
      "FR008_JP",
      "FR009_JP",
      "FR010_JP",
      "FR013_JP",
      "FR017_JP",
      "FR018_JP",
    ],
  },
  {
    value: "GE",
    label: "Georgia",
    selectedLocations: ["GE001_JP"],
  },
  {
    value: "DE",
    label: "Germany",
    selectedLocations: [
      "DE003_JP",
      "DE005_JP",
      "DE001_JP",
      "DE999_JP",
      "DE006_JP",
      "DE007_JP",
    ],
  },
  {
    value: "GH",
    label: "Ghana",
    selectedLocations: ["GH001_JP"],
  },
  {
    value: "GR",
    label: "Greece",
    selectedLocations: ["GR001_JP", "JP_Lamia"],
  },
  {
    value: "GT",
    label: "Guatemala",
    selectedLocations: ["GT"],
  },
  {
    value: "HN",
    label: "Honduras",
    selectedLocations: ["HN"],
  },
  {
    value: "HK",
    label: "China Hong Kong",
    selectedLocations: ["HK"],
  },
  {
    value: "HU",
    label: "Hungary",
    selectedLocations: ["HU001_JP", "HU003_JP"],
  },
  {
    value: "IN",
    label: "India",
    selectedLocations: [
      "IN",
      "IN999_JP",
      "IN045_JP",
      "IN047_JP",
      "IN069_JP",
      "IN009_JP",
    ],
  },
  {
    value: "ID",
    label: "Indonesia",
    selectedLocations: ["ID002_JP", "ID999_JP", "4048_JP", "4004_JP"],
  },
  {
    value: "IE",
    label: "Ireland",
    selectedLocations: ["IE001_JP"],
  },
  {
    value: "IL",
    label: "Israel",
    selectedLocations: ["IL"],
  },
  {
    value: "IT",
    label: "Italy",
    selectedLocations: ["IT009_JP"],
  },
  {
    value: "CI",
    label: "Ivory Coast",
    selectedLocations: ["CI"],
  },
  {
    value: "JP",
    label: "Japan",
    selectedLocations: ["JP"],
  },
  {
    value: "KZ",
    label: "Kazakhstan",
    selectedLocations: ["KZ001_JP"],
  },
  {
    value: "KE",
    label: "Kenya",
    selectedLocations: ["KE"],
  },
  {
    value: "LV",
    label: "Latvia",
    selectedLocations: ["LV"],
  },
  {
    value: "LB",
    label: "Lebanon",
    selectedLocations: ["LB"],
  },
  {
    value: "LT",
    label: "Lithuania",
    selectedLocations: ["LT"],
  },
  {
    value: "MY",
    label: "Malaysia",
    selectedLocations: ["MY003", "MY003_JP"],
  },
  {
    value: "MU",
    label: "Mauritius",
    selectedLocations: ["MU"],
  },
  {
    value: "MX",
    label: "Mexico",
    selectedLocations: [
      "MX004_JP",
      "MX999_JP",
      "MX012_JP",
      "MX012",
      "MX008_JP",
      "4169_JP",
      "MX009_JP",
      "4172_JP",
      "MX001_JP",
      "4141_JP",
      "4182_JP",
    ],
  },
  {
    value: "MA",
    label: "Morocco",
    selectedLocations: ["MA001_JP"],
  },
  {
    value: "NL",
    label: "Netherlands",
    selectedLocations: ["NL"],
  },
  {
    value: "NZ",
    label: "New Zealand",
    selectedLocations: ["NZ002_JP", "NZ003_JP", "NZ009_JP"],
  },
  {
    value: "NI",
    label: "Nicaragua",
    selectedLocations: ["NI"],
  },
  {
    value: "NG",
    label: "Nigeria",
    selectedLocations: ["NG003_JP"],
  },
  {
    value: "NO",
    label: "Norway",
    selectedLocations: ["NO001_JP"],
  },
  {
    value: "PK",
    label: "Pakistan",
    selectedLocations: ["4260_JP", "PK003_JP", "PK004_JP"],
  },
  {
    value: "PA",
    label: "Panama",
    selectedLocations: ["PA"],
  },
  {
    value: "PE",
    label: "Peru",
    selectedLocations: ["PE001_JP", "PE002_JP", "PE999"],
  },
  {
    value: "PH",
    label: "Philippines",
    selectedLocations: ["PH004_JP", "PH003_JP"],
  },
  {
    value: "PL",
    label: "Poland",
    selectedLocations: [
      "PL",
      "PL009",
      "PL004_JP",
      "PL005_JP",
      "PL001_JP",
      "JP_Tomaszow Mazowiecki",
      "PL006_JP",
      "PL009_JP",
    ],
  },
  {
    value: "PT",
    label: "Portugal",
    selectedLocations: ["PT"],
  },
  {
    value: "PR",
    label: "Puerto Rico",
    selectedLocations: ["PR"],
  },
  {
    value: "RO",
    label: "Romania",
    selectedLocations: ["RO003_JP"],
  },
  {
    value: "RU",
    label: "Russia",
    selectedLocations: ["RU"],
  },
  {
    value: "SA",
    label: "Saudi Arabia",
    selectedLocations: ["SA"],
  },
  {
    value: "RS",
    label: "Serbia",
    selectedLocations: ["RS"],
  },
  {
    value: "SG",
    label: "Singapore",
    selectedLocations: ["SG", "002_JP", "SG001_JP"],
  },
  {
    value: "SK",
    label: "Slovak Republic",
    selectedLocations: ["SK001_JP"],
  },
  {
    value: "SI",
    label: "Slovenia",
    selectedLocations: ["AR999_JP", "AR003_JP", "AR006_JP", "AR008_JP"],
  },
  {
    value: "ZA",
    label: "South Africa",
    selectedLocations: ["ZA001_JP", "ZA002_JP"],
  },
  {
    value: "KR",
    label: "South Korea",
    selectedLocations: ["KR"],
  },
  {
    value: "ES",
    label: "Spain",
    selectedLocations: ["ES005_JP"],
  },
  {
    value: "SE",
    label: "Sweden",
    selectedLocations: ["SE999", "SE002_JP"],
  },
  {
    value: "CH",
    label: "Switzerland",
    selectedLocations: ["CH001_JP", "CH002_JP"],
  },
  {
    value: "TW",
    label: "China Taiwan",
    selectedLocations: ["TW001_JP"],
  },
  {
    value: "TH",
    label: "Thailand",
    selectedLocations: ["TH", "TH002_JP", "TH005_JP"],
  },
  {
    value: "TR",
    label: "Turkey",
    selectedLocations: ["TR004_JP", "TR006_JP"],
  },
  {
    value: "UA",
    label: "Ukraine",
    selectedLocations: ["UA003_JP"],
  },
  {
    value: "AE",
    label: "United Arab Emirates",
    selectedLocations: ["AE"],
  },
  {
    value: "GB",
    label: "United Kingdom",
    selectedLocations: [
      "GB019_JP",
      "GB034_JP",
      "GB071_JP",
      "GB054_JP",
      "GB029_JP",
      "GB068_JP",
      "GB065_JP",
      "GB999_JP",
      "GB066_JP",
    ],
  },
  {
    value: "US",
    label: "United States",
    selectedLocations: ["US030_JP"],
  },
  {
    value: "UY",
    label: "Uruguay",
    selectedLocations: ["UY"],
  },
  {
    value: "VE",
    label: "Venezuela",
    selectedLocations: ["VE001_JP", "VE002_JP", "VE008_JP"],
  },
  {
    value: "VN",
    label: "Vietnam",
    selectedLocations: ["VN003_JP", "VN001_JP", "VN999_JP"],
  },
]
export const NULL = "null"
export const UNDEFINED = "undefined"
export const searchJob = "What job are you looking for?"
export const Asof = "As of"
export const EDT = "EDT"
export const formRequestPayload = {
  requestDomain: "www.mondelezinternational.com",
  requestCountry: "us",
  requestLanguage: "en",
  requestCampaign: "MDLZ_INTERNATIONAL_COM_MEDIA_CUSTHELP_EMAIL",
  requestInvestorCampaign: "MDLZ_INTERNATIONAL_COM_INVESTOR_CUSTHELP_EMAIL",
  enquiryBusinessType: "business",
  enquiryConsumerType: "consumer",
}
export const SeachNotFound = "No results found. for search term"

export const fuctionFilterSlug = [
  {
    slug: "Research-Development",
    value: "JF00055|JF00056|JF00057|JF00058|JF00059",
  },
  {
    slug: "Mondelez-Digital-Services",
    value: "JF00077|JF00078|JF00079|JF00080|JF00081",
  },
  {
    slug: "Legal",
    value: "JF00042|JF00043",
  },
  {
    slug: "Business-Services",
    value: "JF00005|JF00006|JF00007|JF00008|JF00009",
  },
  {
    slug: "Human-Resources",
    value: "JF00034|JF00035|JF00036",
  },
  {
    slug: "Procurement",
    value: "JF00050|JF00051|JF00052|JF00053",
  },
  {
    slug: "Corporate-Government-Affairs",
    value: "JF00010|JF00011",
  },
  {
    slug: "Engineering",
    value:
      "JF00064|JF00065|JF00066|JF00068|JF00069|JF00070|JF00071|JF00072|JF00073|JF00074|JF00075",
  },
  {
    slug: "Sales",
    value: "JF00060|JF00061|JF00062|JF00063",
  },
  {
    slug: "Finance",
    value: "JF00023|JF00024|JF00025|JF00027|JF00029|JF00030",
  },
  {
    slug: "Manufacturing",
    value: "JF00044|JF00045|JF00046",
  },
  {
    slug: "Marketing",
    value: "JF00047|JF00048|JF00049",
  },
  {
    slug: "Customer-Service-Logistics",
    value:
      "JF00012|JF00013|JF00014|JF00015|JF00016|JF00017|JF00018|JF00019|JF00020",
  },
  {
    slug: "Strategy-Insights-Analytics",
    value: "JF00076",
  },
  {
    slug: "Supply-Chain-Management",
    value:
      "JF00012|JF00013|JF00014|JF00015|JF00016|JF00017|JF00018|JF00019|JF00020",
  },
  {
    slug: "Early-Careers",
    value: "JF00082|JF00083|JF00084",
  },
]
export const PDF_CONST = "assets/"

export const SEARCH_JOB_BREADCRUMB = {
  items: [
    {
      name: "HOME",
      url: "/",
      label: "HOME",
      title: "HOME",
      target: "_self",
      scrollToElementId: null,
      imageType: null,
      gaEventClass: null,
      gaEventLabel: null,
      ariaLabel: null,
    },
    {
      name: "CAREERS",
      url: "/careers/",
      label: "CAREERS",
      title: "CAREERS",
      target: "_self",
      scrollToElementId: null,
      imageType: null,
      gaEventClass: null,
      gaEventLabel: null,
      ariaLabel: null,
    },
    {
      name: "SEARCH JOBS ",
      url: "/careers/jobs/",
      label: "SEARCH JOBS ",
      title: "SEARCH JOBS ",
      target: "_self",
      scrollToElementId: null,
      imageType: null,
      gaEventClass: null,
      gaEventLabel: null,
      ariaLabel: null,
    },
  ],
}
